import { render } from "./BlackFriday50.vue?vue&type=template&id=54fd3240&scoped=true"
import script from "./BlackFriday50.vue?vue&type=script&lang=js"
export * from "./BlackFriday50.vue?vue&type=script&lang=js"

import "./BlackFriday50.vue?vue&type=style&index=0&id=54fd3240&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fd3240"]])

export default __exports__